export const appCache = {
  users: null,
  roles: null,
  tenants: null,
  repositories: null,
};

export const clearAppCache = () => {
  appCache.users = null;
  appCache.roles = null;
  appCache.tenants = null;
  appCache.repositories = null;
};
